/**
 * Sets/gets KmzData object into IndexedDB. If IndexedDB fails for any reason,
 * it falls back to localStorage.
 */

import * as idb from 'idb-keyval';
import { RouteData } from './route-data';

const DB_KEY = 'kmz-data-0';

export async function set(data: RouteData) {
  try {
    await idb.clear();
    await idb.set(DB_KEY, data);
  } catch (e) {
    console.error(e);
    localStorage.setItem(DB_KEY, JSON.stringify(data));
  }
}

export async function get(): Promise<RouteData|undefined> {
  let data: RouteData|undefined;
  try {
    data = (await idb.get(DB_KEY)) as RouteData|undefined;
  } catch (e) {
    console.error(e);
  }
  if (data) {
    return data;
  }
  const json = localStorage.getItem(DB_KEY);
  if (json) {
    return JSON.parse(json) as RouteData;
  }
  return undefined;
}